import { Component, onMount } from "solid-js";
import {
  publishGlobalErrorModalView,
  publishGlobalErrorRefreshClick,
  publishGlobalErrorReturnClick,
} from "@/services/analytics.service";

interface GlobalErrorModalProps {
  onRefresh: () => void;
  onExit: () => void;
}

const GlobalErrorModal: Component<GlobalErrorModalProps> = (props) => {
  onMount(() => {
    publishGlobalErrorModalView();
  });

  return (
    <fd-mfe-modal-dialog prop:open={true} class="text-FsBaseText">
      <h2 slot="modal-dialog-header">An error occurred</h2>
      <p slot="modal-dialog-body">
        We are currently unable to process your request due to an unexpected
        internal error. Please try again later.
      </p>
      <fd-mfe-modal-dialog-footer slot="modal-dialog-footer">
        <fd-mfe-button
          onClick={() => {
            publishGlobalErrorReturnClick();
            props.onExit();
          }}
        >
          Return to marketing
        </fd-mfe-button>
        <fd-mfe-button
          onClick={() => {
            publishGlobalErrorRefreshClick();
            props.onRefresh();
          }}
          prop:rank="secondary"
        >
          Refresh page
        </fd-mfe-button>
      </fd-mfe-modal-dialog-footer>
    </fd-mfe-modal-dialog>
  );
};

export default GlobalErrorModal;
